import { render, staticRenderFns } from "./b-ticket-header.vue?vue&type=template&id=33225218&scoped=true"
import script from "./b-ticket-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-header.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-header.vue?vue&type=style&index=0&id=33225218&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33225218",
  null
  
)

export default component.exports